import type { Setlist, WorkspaceState } from './Workspace';

export const visualSetlists: Setlist[] = [
  {
    id: 'setlist-1',
    title: 'Serata al Teatro',
    group_name: 'The Blue Notes',
    updated_at: '2026-08-12T12:00:00Z',
    proposal_ids: ['chain-1'],
  },
  {
    id: 'setlist-2',
    title: 'Live d’estate',
    group_name: 'The Blue Notes',
    updated_at: '2026-08-11T12:00:00Z',
  },
];

export const visualState: WorkspaceState = {
  private_profile: { phone: '+393331234567' },
  songs: [
    {
      id: 'song-1',
      title: 'Albachiara',
      author: 'Vasco Rossi',
      source_url: 'https://example.com',
    },
    {
      id: 'song-2',
      title: 'La nuova stella di Broadway',
      author: 'Cesare Cremonini',
      source_url: null,
    },
  ],
  items: [
    ['item-1', 'Albachiara', 'Vasco Rossi', 'chain-1', 0],
    ['item-2', 'Sally', 'Vasco Rossi', 'chain-1', 1],
    ['item-3', 'Vita spericolata', 'Vasco Rossi', null, null],
    ['item-4', 'Marmellata #25', 'Cesare Cremonini', null, null],
    ['item-5', 'Salirò', 'Daniele Silvestri', null, null],
    ['item-6', 'Giudizi universali', 'Samuele Bersani', null, null],
    ['item-7', 'Centro di gravità permanente', 'Franco Battiato', null, null],
    ['item-8', 'Una musica può fare', 'Max Gazzè', null, null],
  ].map(([id, title, author, block_id, block_ordinal], position) => ({
    id: id as string,
    song_id: null,
    title: title as string,
    author: author as string,
    source_url: position === 0 ? 'https://example.com' : null,
    position,
    block_id: block_id as string | null,
    block_ordinal: block_ordinal as number | null,
    is_proposal: position === 0 || position === 1,
  })),
  collaborators: [
    {
      profile_id: 'member-2',
      display_name: 'Marco',
      instrument_role: 'Batteria',
      phone: '+393401112233',
    },
  ],
  transfers: [
    {
      id: 'transfer-1',
      status: 'pending',
      created_at: '2026-08-15T10:30:00Z',
      sender_id: 'member-2',
      sender_phone: '+393401112233',
      sender_instrument: 'Batteria',
      origin: 'collaborator',
      items: [
        { title: 'Centro di gravità permanente', author: 'Franco Battiato', ordinal: 0 },
      ],
    },
  ],
  pending_invites: [{ id: 'invite-1', expires_at: '2026-08-18T12:00:00Z' }],
  structures: {
    chains: [{ id: 'chain-1', itemIds: ['item-1', 'item-2'] }],
    branches: [
      {
        id: 'branch-1',
        originId: 'item-3',
        mainPathIds: ['item-4', 'item-5'],
        branchPathIds: ['item-6', 'item-7'],
      },
    ],
    alternatives: [{ id: 'alternative-1', originId: 'item-4', alternativeId: 'item-8' }],
  },
};
